import { useMediaThematicBlockRemoveFromCompanyMutation } from '@shared/api/graphql/generated';

const useCompanyThematicBlockRemove = () => {
  const [mutation, data] = useMediaThematicBlockRemoveFromCompanyMutation();

  const request = async (companyThematicBlockId: string) => {
    const mutationResult = await mutation({
      variables: {
        input: {
          companyThematicBlockId,
        },
      },
    });
    return !!mutationResult.data?.result?.ok;
  };

  return {
    request,
    error: data.error,
    loading: data.loading,
  };
};

export default useCompanyThematicBlockRemove;
